import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { Button } from '../Button';
import { AlertTriangleIcon, CheckCircleBrokenIcon, InfoCircleIcon, XCloseIcon } from '../Icons';
import { StackItem } from '../Layout';
import { renderWithTooltip } from '../Tooltip';
import { LabelWithHint } from '../Typography/LabelWithHint';
import { StyledAlert } from './styled';
import { tokens } from './tokens';
import { Variant } from './types';
const IconMap = {
    warning: /*#__PURE__*/ _jsx(AlertTriangleIcon, {
        type: "default",
        color: tokens.Alert.warning.iconColor
    }),
    error: /*#__PURE__*/ _jsx(InfoCircleIcon, {
        type: "default",
        color: tokens.Alert.error.iconColor
    }),
    info: /*#__PURE__*/ _jsx(InfoCircleIcon, {
        type: "default",
        color: tokens.Alert.info.iconColor
    }),
    success: /*#__PURE__*/ _jsx(CheckCircleBrokenIcon, {
        type: "default",
        color: tokens.Alert.success.iconColor
    })
};
const CloseButton = styled(Button)`
  self-align: flex-start;
`;
export function Alert({ variant = Variant.warning, banner, children, icon = IconMap[variant], showIcon = true, closable, onClose, tooltip, hint, 'data-test-id': dataTestId = 'alert', ...restProps }) {
    let alertUI = /*#__PURE__*/ _jsxs(StyledAlert, {
        variant: variant,
        direction: "horizontal",
        alignY: "top",
        banner: banner,
        role: "alert",
        ...restProps,
        "data-test-id": dataTestId,
        "data-state": variant,
        children: [
            showIcon && /*#__PURE__*/ _jsx("span", {
                children: icon
            }),
            /*#__PURE__*/ _jsx(StackItem, {
                grow: "1",
                children: children
            }),
            closable && /*#__PURE__*/ _jsx("span", {
                children: /*#__PURE__*/ _jsx(CloseButton, {
                    variant: "plain",
                    icon: /*#__PURE__*/ _jsx(XCloseIcon, {
                        type: "default"
                    }),
                    onClick: onClose
                })
            })
        ]
    });
    if (tooltip) {
        alertUI = /*#__PURE__*/ _jsx(_Fragment, {
            children: renderWithTooltip(alertUI, tooltip)
        });
    }
    if (hint) {
        alertUI = /*#__PURE__*/ _jsx(LabelWithHint, {
            hint: hint,
            children: alertUI
        });
    }
    return alertUI;
}
